export default __webpack_public_path__ + "static/media/huntinghawk.d0ff985b.png";